export const UNKNOWN_DIMENSION_NAMES: Record<string, string> = {
  UNKNOWN_LINE_ITEM_NAME: 'Unknown Ad Group',
  UNKNOWN_MEDIA_TYPE_NAME: 'Unknown Media Type',
  UNKNOWN_AUDIENCE_NAME: 'Unknown Audience',
};

// Per-impression video metrics: their value is only meaningful relative to
// impressions on the same row. Adform's event feed delivers orphan video
// events (no matching impression) that surface as completion counts on rows
// with zero impressions — render those as N/A instead.
export const VIDEO_PER_IMPRESSION_METRICS: ReadonlySet<string> = new Set([
  'PCT_25',
  'PCT_50',
  'PCT_75',
  'PCT_100',
  'VCR',
]);
